export default {
    state: {
        superBoms: [],
    },
    actions: {
        async fetchSuperBoms(ctx) {
            const requestParams = {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    'credentials': "same-origin",
                },
            };
            console.log('Authorization')
            console.log(requestParams)
            const res = await fetch("/api/superbom/", requestParams);
            const superBoms = await res.json();
            for (let bom of superBoms) {
                bom['html'] = false
            }
            ctx.commit('updateSuperBoms', superBoms)
            console.log(superBoms)
        },
        async addSuperBom(ctx, versionName) {
            const superBoms = ctx.state.superBoms;
            const requestPostOptions = {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    'credentials': "same-origin",
                },
                body: JSON.stringify({
                    'super_bom_flag': true,
                    'version': versionName,
                    'children': [],
                })
            };
            const resPost = await fetch("/api/superbom/", requestPostOptions)
            const superPostBom = await resPost.json();
            console.log('requestPostOptions')
            console.log(requestPostOptions)
            superBoms.push(superPostBom);
            ctx.commit('updateSuperBoms', superBoms);
        },
        async actionDeleteSuperBom(ctx, supebomId) {
            const superBoms = ctx.state.superBoms.filter(bom => bom.id !== supebomId)
            const requestOptions = {
                method: "DELETE",
                headers: {
                    "Content-Type": "application/json",
                    'credentials': "same-origin",
                },
            };
            await fetch("/api/superbom/" + supebomId + "/", requestOptions).then(_ => {
                ctx.commit('updateSuperBoms', superBoms)
            });
        },
    },

    mutations: {
        updateSuperBoms(state, superBoms) {
            state.superBoms = superBoms
        },
    },

    getters: {
        superBoms(state) {
            return state.superBoms.filter(bom => {
                return bom.super_bom_flag
            })
        },
    }
}